import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_branch_label_link_RowClass } from '../../../dbschema';

export class BranchLabelLinkContainerModel extends BaseContainerModel {
  bl_fi_branch_label_link: bl_fi_branch_label_link_RowClass = new bl_fi_branch_label_link_RowClass();
}